import type { FaireProductEntity } from "../../entity_types/product";

export const p_sxhfejx49x: FaireProductEntity = {
  token: "p_sxhfejx49x",
  type: "product",
  name: "9-Tail Fox Carving Fluorite - 3 per lot ON SALE!",
  brandToken: "b_gbfbknczne",
  brandName: "Crystal Deal· Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/bc7468f090507cff5516fbe59e0a9a2b720df41daa2a1f9c028075a056482af4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6196de22fcc6b71c8aeaf9c8b1e8067df6acd086c00041442d75e260f2621c01.jpeg",
    "https://cdn.faire.com/fastly/40abac6d1de44a38761e0472b9f68caf5befaf0e65a873854e50528d770f59fc.jpeg",
  ],
  priceDollars: 30.49,
  description:
    "This listing is for three 9-Tail Fox carving in Fluorite. These are 2 inches each and you are going to get a set very similar to the one in the picture. \n\nmaterial is from China, and we ship from the US. ",
  tags: [],
  msrpDollars: 60.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:45.884Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
